import UICardActions from '@mui/material/CardActions';
import { LinkButton } from '@backstage/core-components';
import { useTheme } from '@material-ui/core/styles';
import { CardLinks, CardProps, CardVariant } from '../../lib/types';
import { Card } from '../../core/card';

export const MinimalCard = (props: CardProps) => {
  const theme = useTheme();
  const { actionRoute, actionLabel, target } = props;

  const cardTarget = target ?? '_self';

  const cardProps = {
    ...props,
    target: cardTarget,
    variant: CardVariant.minimal,
    actionable: !!(actionRoute || actionLabel),
  };

  const Links = ({ cardLinks }: { cardLinks: CardLinks }) => {
    return (cardLinks || []).map(link => {
      return (
        <LinkButton
          key={link.href}
          to={link.href}
          variant="text"
          color="default"
          size="small"
          underline="none"
        >
          {link.label || link.href}
        </LinkButton>
      );
    });
  };

  return (
    <Card.Root {...cardProps}>
      <Card.Card>
        <Card.Actionable
          cardProps={cardProps}
          style={{ padding: theme.spacing(0) }}
        >
          <Card.Title />
          {cardProps.description && <Card.Content />}
          {cardProps.actionLabel && <Card.Actions />}
        </Card.Actionable>

        {cardProps.links && (
          <UICardActions>
            <Links cardLinks={cardProps.links} />
          </UICardActions>
        )}
      </Card.Card>
    </Card.Root>
  );
};
